import Artifact from "@/models/Artifact";
import Component from "@/models/Component";
import Model from "@/models/Model";
import Product from "@/models/Product";

export default class WarehouseItemArtifact extends Model {
  static type = "warehouseItemArtifacts";
  name: string;
  sku: string;
  zoom: number;
  rotationX: number;
  rotationY: number;
  rotationZ: number;
  lightsCount: number;
  lightsIntensity: number;
  lightsRadiusMultiplier: number;
  product: Product;
  artifact: Artifact;
  components: Component[];

  get configurableComponents() {
    return this.components.filter(
      (o) => (o.configurable || o.printable) && o.visible
    );
  }
}
